module.exports = __webpack_public_path__ + "img/bagging_woodpacking_en.db131487.svg";